module.exports = __webpack_public_path__ + "static/krassi-b9f769a9cfca9db741de9918080d1ae9.png";